import { atomWithStorage } from "jotai/utils";
import { StoreKeys } from "./store-keys";
/**
 * Interface for empresa data
 */
export interface Dates {
  fromDate: string;
  toDate: string;
}

export const datesAtom = atomWithStorage<Dates | null>(
  `Xtremis_CarbonTech_${StoreKeys.Dates}`,
  null,
);
